<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M8.3 5.3A6.6 6.6 0 0 1 10 5c4.5 0 7.5 5 7.5 5a13 13 0 0 1-2.3 2.8M5.4 6.7A13 13 0 0 0 2.5 10s3 5 7.5 5c1 0 1.9-.2 2.7-.6M8.4 8.4a2.2 2.2 0 0 0 3.1 3.1M3 3l14 14"/></svg>
</template>
